import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Menu,
  MenuItem,
  Typography,
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import LaboratoryFormModal from '../laboratoryFormModal';

// List, row menu and dialogs shared by the web and mobile laboratory register.
export default function LaboratoryListContent({ screen }) {
  const {
    laboratories,
    isLoading,
    anchorEl,
    clickMenu,
    closeMenu,
    isModalOpen,
    laboratoryToEdit,
    openEditModal,
    closeModal,
    handleSaved,
    isConfirmModalOpen,
    openConfirmModal,
    closeConfirmModal,
    confirmDelete,
  } = screen;

  const describeContact = (laboratory) =>
    [laboratory.contactName, laboratory.phone].filter(Boolean).join(' · ');

  return (
    <>
      <List>
        {laboratories.length === 0 && !isLoading ? (
          <Typography variant="body2" color="text.secondary" sx={{ py: 2, textAlign: 'center' }}>
            Nenhum laboratório cadastrado
          </Typography>
        ) : (
          laboratories.map((laboratory) => (
            <React.Fragment key={laboratory.id}>
              <ListItem
                secondaryAction={
                  <IconButton onClick={(event) => clickMenu(event, laboratory)}>
                    <MoreVertIcon />
                  </IconButton>
                }
              >
                <ListItemText
                  primary={laboratory.name}
                  primaryTypographyProps={{ fontWeight: '600' }}
                  secondary={describeContact(laboratory) || null}
                />
              </ListItem>
              <Divider component="li" />
            </React.Fragment>
          ))
        )}
      </List>

      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={closeMenu}>
        <MenuItem onClick={openEditModal}>Editar</MenuItem>
        <MenuItem onClick={openConfirmModal} sx={{ color: 'error.main' }}>
          Excluir
        </MenuItem>
      </Menu>

      <LaboratoryFormModal
        open={isModalOpen}
        onClose={closeModal}
        onSave={handleSaved}
        laboratory={laboratoryToEdit}
      />

      <Dialog open={isConfirmModalOpen} onClose={closeConfirmModal} maxWidth="xs" fullWidth>
        <DialogTitle sx={{ fontWeight: 'bold' }}>Excluir laboratório</DialogTitle>
        <DialogContent dividers>
          <DialogContentText>
            O laboratório deixará de aparecer nas listas de seleção. Os envios já registrados para
            ele continuam no histórico. Deseja continuar?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeConfirmModal}>Cancelar</Button>
          <Button onClick={confirmDelete} variant="contained" color="error">
            Excluir
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

LaboratoryListContent.propTypes = {
  screen: PropTypes.shape({
    laboratories: PropTypes.array.isRequired,
    isLoading: PropTypes.bool.isRequired,
    anchorEl: PropTypes.object,
    clickMenu: PropTypes.func.isRequired,
    closeMenu: PropTypes.func.isRequired,
    isModalOpen: PropTypes.bool.isRequired,
    laboratoryToEdit: PropTypes.object,
    openEditModal: PropTypes.func.isRequired,
    closeModal: PropTypes.func.isRequired,
    handleSaved: PropTypes.func.isRequired,
    isConfirmModalOpen: PropTypes.bool.isRequired,
    openConfirmModal: PropTypes.func.isRequired,
    closeConfirmModal: PropTypes.func.isRequired,
    confirmDelete: PropTypes.func.isRequired,
  }).isRequired,
};
